import { Component, inject } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ICodigosDispositivo } from 'modelos/src';
import { AuxiliaresModule } from '../../../../auxiliares/auxiliares.module';

@Component({
  imports: [AuxiliaresModule, NgTemplateOutlet],
  selector: 'app-detalles-codigos-dispositivos',
  templateUrl: './detalles-codigos-dispositivos.component.html',
  styleUrl: './detalles-codigos-dispositivos.component.scss',
})
export class DetallesCodigosDispositivosComponent {
  data = inject<ICodigosDispositivo>(MAT_DIALOG_DATA);
  private dialogRef =
    inject<MatDialogRef<DetallesCodigosDispositivosComponent>>(MatDialogRef);

  public cerrar(): void {
    this.dialogRef.close();
  }
}
